<app-news-item [newsItem]="newsItem"></app-news-item>
